import React, { useEffect, useState } from "react";
import "./DeviceStatus.css";
import { Fragment } from "react";
import { format } from "date-fns";
import { Box } from "@mui/material";
import Button from "../../Common/Button/Button";
import DataTable from "../../Common/DataTable/DataTable";
import { commonHeaders } from "./DeviceStatusConstants";
import { formatTableHeader } from "../../../utils/general";

const DisplayDeviceStatusData = ({
    deviceCategory,
    deviceStatusData = [],
    setDialog,
    setDialogContents
}) => {
    const [headers, setHeaders] = useState({});

    useEffect(() => {
        const dataHeaders = {};
        deviceStatusData?.map(d => {
            Object?.keys(d?.payload)?.forEach(h => {
                if (!dataHeaders?.hasOwnProperty(h)) {
                    dataHeaders[h] = { header: formatTableHeader(d?.payload[h]?.header !== "" ? d?.payload[h]?.header : h), desc: d?.payload[h]?.desc }
                }
            })
        })
        delete dataHeaders?.ts
        delete dataHeaders?.mo
        delete dataHeaders?.ty

        setHeaders({
            ...commonHeaders,
            ...dataHeaders,
            actions: { header: "Actions", desc: "" }
        })
    }, [deviceStatusData])

    const statusColumns = Object.keys(headers).map((key, ind) => ({
        key,
        label: headers[key]?.header,
        minWidth: key === "ts" ? 200 : key === "actions" ? 110 : 150,
        justifyContent: ind === Object.keys(headers)?.length - 1 ? "flex-end" : "flex-start",
        headerCellSx: {
            maxWidth: 300,
            overflow: "hidden",
            textOverflow: "ellipsis",
        },
        render: (value, row) => {
            if (key === "serialNumber") {
                return <Box>{row.serialNumber}</Box>;
            }

            if (key === "actions") {
                return (
                    <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                        <Button
                            variant="primary"
                            size="small"
                            onClick={() => {
                                setDialogContents({ title: "Status Details", data: row.raw });
                                setDialog(true);
                            }}
                        >
                            View
                        </Button>
                    </Box>
                );
            }

            if (key === "ts") {
                const payloadValue = row?.payload?.[key]?.value;
                return String(payloadValue || "").length > 0 ? (
                    <Box>
                        {format(new Date(Number(payloadValue) * 1000), "dd MMM yyyy, hh:mm a")}
                    </Box>
                ) : (
                    ""
                );
            }

            const payloadEntry = row?.payload?.[key];
            const displayValue = Array.isArray(payloadEntry?.value)
                ? payloadEntry.value.join(", ")
                : payloadEntry?.value ?? "-";

            return (
                <Box className={String(payloadEntry || "").length > 200 ? "breakWord" : ""}>
                    {displayValue}
                </Box>
            );
        },
    }));

    const statusRows = Array.isArray(deviceStatusData)
        ? deviceStatusData.map((element, index) => ({
            rowId: `${element?.payload?.ts?.value || "status"}-${index}`,
            raw: element,
            payload: element?.payload || {},
            serialNumber: index + 1,
        }))
        : [];

    return (
        <Fragment>
            {
                deviceCategory && deviceCategory!=="" && deviceStatusData &&
                <DataTable
                    columns={statusColumns}
                    data={statusRows}
                    rowKey="rowId"
                    minWidth="100%"
                    maxHeight={400}
                    striped={false}
                    hoverEffect={false}
                    tableContainerSx={{ boxShadow: "none", borderRadius: 0 }}
                    sx={{ mb: 2 }}
                    msgForDisplay="No Data found"
                />
            }
        </Fragment>
    );
};

export default DisplayDeviceStatusData